export const DbName = {
  CATEGORY_LIST_DB: "categoryListDB",
  LANGUAGE_LIS_TDB: "languageListDB",
  TEMP_CATEGORY_LIST_DB: "tempCategoryListDB",
};

export const StoreName = {
  CATEGORY_LIST: "categoryList",
  LANGUAGE_LIST: "languageList",
  TEMP_CATEGORY_LIST: "tempCategoryList",
};

export const DbVersion = { FIRST: 1 };
